<template>
  <div class="sidebarBox  fr">
    <div :class="{ 'con-left': true, small: isSmall }">
      <div class="peopleInfo">
        <template>
            <div class="topbook" style="position: relative">
                <img v-if="bookdetail.iconUrl" v-lazy="imgURL + bookdetail.iconUrl" alt="" />
                <img v-else src="~img/default.png" alt="" />
                <div class="bookStatus">
                  <img v-if="bookdetail.status==0" src="~img/author/tag_cg@2x.svg" alt="">
                  <img v-if="bookdetail.status==2" src="~img/author/tag_gk@2x.svg" alt="">
                  <img v-if="bookdetail.status==-1" src="~img/author/tag_xj@2x.svg" alt="">
                </div>
            </div>
          <p class="name">{{ bookdetail.name?bookdetail.name:"作品名" }}</p>
          <div>
            <div>
                <template v-if="bookdetail.status==2">
                <a href="javaScript:">已更新{{bookdetail.words}}字</a>
                <a href="javaScript:"> | </a>
                <a href="javaScript:" >共<span style="color:#48A2DF;">{{bookdetail.chapterNum}}</span>章</a>
                </template>
                <a href="javaScript:" v-else-if="bookdetail.status==-1">作品被下架记得联系编辑哦~</a>
                 <a href="javaScript:" v-else>旷世神作酝酿中...</a>
            </div>
          </div>
          <router-link
            class="useroption"
            style="font-size: 14px;display:block;text-align:center"
            to="/phoneLogin"
            v-if="!info"
            >登录</router-link
          >
        </template>
        <template> </template>
      </div>
      <ul class="person-center">
        <li v-for="(item, index) in navlist" :key="item.name">
          <router-link
            v-if="index==0"
            :to="item.url"
            :class="{ active: true, link: link }"
            >{{ item.name }}</router-link
          >
          <span @click="applyOpen" class="setEnd" v-else-if="index==1">{{
            item.name
          }}</span>
          <span @click="bookendhint" class="setEnd" v-else>{{
            item.name
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    navlist: Array,
    isSmall: Boolean,
    oIndex: Number,
    link: Boolean,
    isSet: Boolean,
    isAuthor: Boolean,
    totalPage: Number,
    sAuthor: Boolean,
    bookdetail: Object
  },
  computed: mapState({
    info: state => (state.user.img ? state.user.img : null)
  }),
  methods: {
    bookendhint() {
      this.$emit("isShowhint", true);
    },
    applyOpen() {
        this.$emit("openApply", true)
    }
  }
};
</script>

<style lang="stylus" scoped>
.con-left
    width 176px
    height 100%
    background rgba(255, 255, 255, 1)
    border 1px solid rgba(239, 239, 239, 1)
    padding-top 20px
    box-sizing border-box
    position absolute
    left 0
    &.small
        width 176px
    .peopleInfo
        margin 0 8px 26px
        padding-bottom 10px
        border-bottom 2px solid #EFEFEF
        text-align cener
        .topbook
            width:80px;
            height:112px;
            margin 0 auto
            img
                width:80px;
                height:112px;
                border-radius:2px;
                display block
        .bookStatus
            position absolute
            top -3px
            right 5px
            img
                width 31px
                height 32px
        .name
            margin 18px auto 8px
            font-size 14px
            font-family PingFangSC-Regular
            font-weight 400
            color rgba(51, 51, 51, 1)
            text-align center
        div
            text-align center
            a
                height 17px
                font-size 12px
                font-family PingFangSC-Regular
                font-weight 400
                color rgba(136, 136, 136, 1)
                line-height 17px
                cursor auto
    .person-center
        li
            width 100%
            height 40px
            a
                display block
                text-align center
                font-size 14px
                font-family PingFangSC-Regular
                font-weight 400
                color #7992A4
                line-height 40px
                border-left 6px solid rgba(255, 255, 255, 1)
                &.link
                    &.router-link-active
                        background rgba(239, 239, 239, 1)
                        border-left 6px solid #48A2DF
                        color #48A2DF
                &.router-link-exact-active
                    background rgba(239, 239, 239, 1)
                    border-left 6px solid #48A2DF
                    color #48A2DF
                &.active
                    background rgba(239, 239, 239, 1)
                    border-left 6px solid #48A2DF
                    color #48A2DF
                &:hover
                    background rgba(239, 239, 239, 1)
                    border-left 6px solid #48A2DF
                    color #48A2DF
            span
                display block
                text-align center
                font-size 14px
                font-family PingFangSC-Regular
                font-weight 400
                color #7992A4
                line-height 40px
                border-left 6px solid rgba(255, 255, 255, 1)
                cursor pointer
</style>
